module.exports = __webpack_public_path__ + "5c9c48b19cd0ec2ad7aae46daf57b258.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201603_Presse_AVANGA_Sputnika_421KB.jpg
// module id = 564
// module chunks = 0